import { forwardRef } from "react";
import { FormControl } from "@/components/ui/form";
import { Select as SelectUI, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BaseQuestionProps } from "../..";
import { cn } from "@/lib/utils";

interface SelectProps extends BaseQuestionProps {
  options?: { value: string; label: string }[];
  storedValue?: Date | string;
  className?: string;
}

export const Select = forwardRef<HTMLButtonElement, SelectProps>(({ placeholder, disabled, field, options, className }, ref) => {
  return (
    <SelectUI onValueChange={field.onChange} disabled={disabled} value={field.value}>
      <FormControl>
        <SelectTrigger
          ref={ref}
          className={cn(
            `${disabled ? "border-slate-400 bg-slate-200" : "border-slate-400"} my-2 w-full font-light sm:max-w-[50%] md:my-3 md:max-w-[70%]`,
            className,
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {options?.map((option) => (
          <SelectItem className="font-light" key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </SelectUI>
  );
});

Select.displayName = "Select";
